import { Steps as AntdSteps } from 'antd';
import React from 'react';

const Steps = ({
  current = 0,
  progressDot = false,
  size = '',
  items = [],
  error = false,
  labelPlacement,
  className = '',
}) => (
  <AntdSteps
    progressDot={progressDot}
    current={current}
    size={size}
    items={items}
    status={error ? 'error' : 'process'}
    labelPlacement={labelPlacement}
    className={className}
  />
);

export default Steps;
